<sxw-side-dialog
  class="no-scrollbar"
  (onHideDialog)="hideDialog()"
  appendTo="body"
  outletName="popups"
  theme="sxw-popup-cards"
  class="no-sidebar-header no-scrollbar">
  <ng-template #header> </ng-template>
  <ng-template #content>
    <h3 class="my-5px mt-10px">{{ "verifyOtp.header" | translate }}</h3>
    <h4 class="color-gray f-w-normal my-5px">{{ "verifyOtp.subheader" | translate }}</h4>
    <sxw-form [formModel]="formModel" class="v-email-otp">
      <app-verify-otp-form></app-verify-otp-form>
      <sxw-button class="mt-30px d-block" [label]="buttonLabel" theme="btn otp-style" [disabled]="disabled" (onClick)="resendOtp()"> </sxw-button>
      <sxw-button
        type="submit"
        class="submit-btn"
        [styles]="{ width: '100%', marginTop: '1rem' }"
        label="continue"
        [disabled]="formModel.formGroup().invalid"
        [isLoading]="isLoading"
        (onClick)="verifyOtp()">
      </sxw-button>
    </sxw-form>
  </ng-template>
</sxw-side-dialog>
